<template>
    <v-tab-item :value="tabValue" class="fill-height">
        <v-layout column justify-center align-center fill-height style="overflow-y: hidden">
            <v-card-subtitle>
                <v-chip>{{ meeting?.title }}</v-chip>
            </v-card-subtitle>
            <v-card-title>해당 미팅의 매칭이 완료되었습니다.</v-card-title>
            <v-card-subtitle class="text-center">
                <span class="primary--text"> {{ schedule?.dateText }} </span> 에 <br />
                <span class="secondary--text">{{ meeting?.company?.name }}</span> 업체와 미팅 일정이 설정되었습니다.
            </v-card-subtitle>
            <v-card-actions class="justify-center">
                <v-btn v-if="editable" outlined @click="$emit('prev')"> 미팅 일정 변경하기 </v-btn>
                <slot name="tab-complete-actions" />
            </v-card-actions>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initMeeting, initMeetingSchedule, MEETING_SCHEDULE_STATES } from "@/assets/variables";

export default {
    props: {
        meeting: { type: Object, default: initMeeting },
        schedule: { type: Object, default: initMeetingSchedule },
        tabValue: { type: String },
    },
    computed: {
        editable() {
            return [null, MEETING_SCHEDULE_STATES.AWAITING.value].includes(this.schedule?.state);
        },
    },
};
</script>

<style>
</style>